
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#d20000","d":"M0 0h56v28H0z"}}),_c('g',{attrs:{"fill":"#ffe600"}},[_c('path',{attrs:{"d":"M0 0h8.4L28 13.5 47.6 0H56L0 28h8.4L28 14.5 47.6 28H56zm56 11.2v5.6L0 11.2v5.6zM25.2 0L28 12l2.8-12zm0 28L28 16l2.8 12z"}}),_c('circle',{attrs:{"cx":"28","cy":"14","r":"4.5","stroke":"#d20000"}})])])
          )
        }
      }
    